exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#url[data-v-4d1971ac] {\n  border-radius: 0;\n}\n", ""]);

// exports
